import 'store/bolt/pixels.js';
import Store from 'store/store';

let scriptLoaded;

Store.on('SET_COOKIES', (cats = []) => {
	if (cats.indexOf('PERFORMANCE') !== -1 && !scriptLoaded) {
		loadScript();
	}
});

const loadScript = () => {
	!function (w, d, t, u) {
		let a = d.createElement(t);
		a.async = 1;
		a.src = u + "?url=" + encodeURIComponent(w.location.href) + "&ref=" + encodeURIComponent(d.referrer);
		a.onload = () => {
			scriptLoaded = true;
		};
		let s = d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(a, s);

	}(window, document, 'script', 'https://a.ad.gt/api/v1/u/matches/28');
};
